import { TableProps, Table, TableColumnProps } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useReportActivityAnalyzeFilters } from 'business/shift-report/report-analyze/pages/activity-analyze/providers/filters';
import { formatReportActivityAnalyzeTitleUnit } from 'business/shift-report/report-analyze/pages/activity-analyze/services/format-activity-analyze-unit';
import {
  ReportActivityAnalyzeGraphPoint,
  ReportActivitySerie,
} from 'business/shift-report/report-analyze/pages/activity-analyze/types';

type ReportActivityAnalyzeTableProps = {
  reportActivityAnalyzeGraphData: ReportActivityAnalyzeGraphPoint[];
  reportActivitySeries: ReportActivitySerie[];
};

const COLUMN_WIDTH = 125;
const SCROLL_TRIGGER_VALUE = 500;

const ReportActivityAnalyzeTable = ({
  reportActivityAnalyzeGraphData,
  reportActivitySeries,
}: ReportActivityAnalyzeTableProps) => {
  const { t } = useTranslation();
  const filters = useReportActivityAnalyzeFilters();

  const firstColumn = {
    title: t('reportAnalyze.activityAnalyze.input.groupByOptions', {
      context: filters.groupByType,
    }),
    dataIndex: 'rowDisplay',
    key: 'rowDisplay',
    width: COLUMN_WIDTH,
  } satisfies TableColumnProps;

  const columns = [
    firstColumn,
    ...reportActivitySeries.map((activity) => {
      return {
        title: formatReportActivityAnalyzeTitleUnit(activity.nameLevelMax),
        dataIndex: activity.id,
        key: activity.id,
        width: COLUMN_WIDTH,
      } satisfies TableColumnProps;
    }),
  ] satisfies TableProps['columns'];

  return (
    <Table
      columns={columns}
      dataSource={reportActivityAnalyzeGraphData}
      pagination={false}
      bordered
      size="small"
      rowKey={(record) => record.rowDisplay}
      scroll={{ y: SCROLL_TRIGGER_VALUE }}
    />
  );
};

export default ReportActivityAnalyzeTable;
